export const TESTIMONIALS_DATA = [
  {
    name: "JENNIFER B., PA-C",
    image: "/images/testimonials/dr-1024.png",
    // thumbnail: "/images/testimonials/jeniffer.jpg",
    content:
      "As a Physician Surgical Associate, I've found it to be an invaluable resource in connecting with peers across different specialties. The platform's user-friendly interface makes it easy to share insights, discuss complex cases, and seek advice from experienced professionals. It has truly enhanced my practice and broadened my professional network. Universal is highly recommended!",

    role: "GENERAL SURGERY PA",
    info: "",
    url: "",
  },
  {
    name: "CAITLIN B., PA-C",
    image: "/images/testimonials/dr-1045.png",
    // thumbnail: "/images/testimonials/kelsey.jpg",
    content:
      "I can't speak highly enough about the utility of this website for PA like myself. It provides a centralized hub for accessing the latest research, discussing best practices, & exchanging ideas with colleagues in the field. Whether I'm seeking guidance on a challenging diagnosis or looking for career development opportunities, this platform has consistently delivered. Kudos to the team behind it!",

    role: "BREAST SURGERY PA",
    info: "",
    url: "",
  },
  {
    name: "ARIELLE A., PA-C",
    image: "/images/testimonials/dr-1041.png",
    // thumbnail: "/images/testimonials/arielle.jpg",
    content:
      "Universal has been a game-changer for me as a PA working in surgery. Not only does it foster collaboration among peers, but it also serves as a repository of resources ranging from surgical techniques to post-operative care protocols. The ability to connect with other professionals in real-time has been invaluable in improving patient outcomes and staying updated on industry trends",

    role: "ROBOTIC SURGERY PA",
    info: "",
    url: "",
  },
];

import { COMPANY_NAME } from "../utils/constants";

export const PROVIDER_TESTIMONIAL = [
  {
    name: "JENNIFER",
    info: "GENERAL SURGICAL SPECIALIST",
    image: "/images/providers/jeniffer.webp",
    // thumbnail: "/images/providers/jeniffer.jpg",
    content:
      "Highly recommended! This site connects Surgical Assistants across specialties, making it easy to share insights and seek advice, enhancing both practice and network.",

    url: "https://www.youtube.com/watch?v=-CDmil8eFPg",
  },
  {
    name: "KELSEY",
    info: "ORTHOPAEDIC SPECIALIST",
    image: "/images/providers/kelsey.webp",
    // thumbnail: "/images/providers/kelsey.jpg",
    content:
      "Kudos! This site is vital for Physician Assistants, offering research access, best practice discussions, and career guidance. Consistently invaluable.",

    url: "https://www.youtube.com/watch?v=-CDmil8eFPg",
  },
  {
    name: "ARIELLE",
    info: "ROBOTIC SURGICAL SPECIALIST",
    image: "/images/providers/arielle.webp",
    // thumbnail: "/images/providers/arielle.jpg",
    content:
      "This site is a game-changer for surgical Physician Assistants. It fosters peer collaboration and offers a wealth of resources. Real-time connections improve patient outcomes. Grateful for this platform.",

    url: "https://www.youtube.com/watch?v=-CDmil8eFPg",
  },
];
